// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"7ae28348","741":"ce8a6707"}[chunkId] + ".chunk.css";
};